System.register(["./dyn-jsx-runtime.js", "./dyn-index.js", "./dyn-goober.modern.js", "./dyn-embla-carousel-react.esm.js", "./dyn-index2.js", "./dyn-DefaultPropsProvider.js", "./dyn-useForkRef.js", "./dyn-index3.js"], function(exports, module) {
  "use strict";
  var clsx, jsxRuntimeExports, React, reactExports, React$1, u, j, useEmblaCarousel, useMobile, usePrevNextButtons, PrevButton, NextButton, THEME_ID, defaultTheme, generateUtilityClass, generateUtilityClasses, useDefaultProps, styled, alpha, composeClasses, memoTheme, getOverlayAlpha, capitalize, useEnhancedEffect, useTheme$1, useForkRef, setRef, ReactDOM, reactDomExports;
  return {
    setters: [(module2) => {
      clsx = module2.c;
      jsxRuntimeExports = module2.j;
    }, (module2) => {
      React = module2.R;
      reactExports = module2.r;
      React$1 = module2.b;
    }, (module2) => {
      u = module2.u;
      j = module2.j;
    }, (module2) => {
      useEmblaCarousel = module2.u;
    }, (module2) => {
      useMobile = module2.u;
      usePrevNextButtons = module2.a;
      PrevButton = module2.P;
      NextButton = module2.N;
    }, (module2) => {
      THEME_ID = module2.h;
      defaultTheme = module2.i;
      generateUtilityClass = module2.g;
      generateUtilityClasses = module2.a;
      useDefaultProps = module2.u;
      styled = module2.s;
      alpha = module2.f;
      composeClasses = module2.b;
      memoTheme = module2.m;
      getOverlayAlpha = module2.j;
      capitalize = module2.d;
    }, (module2) => {
      useEnhancedEffect = module2.u;
      useTheme$1 = module2.a;
      useForkRef = module2.b;
      setRef = module2.s;
    }, (module2) => {
      ReactDOM = module2.R;
      reactDomExports = module2.a;
    }],
    execute: function() {
      exports("default", UserStory);
      function createChainedFunction(...funcs) {
        return funcs.reduce((acc, func) => {
          if (func == null) {
            return acc;
          }
          return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
          };
        }, () => {
        });
      }
      function ownerDocument(node) {
        return node && node.ownerDocument || document;
      }
      function ownerWindow(node) {
        const doc = ownerDocument(node);
        return doc.defaultView || window;
      }
      let globalId = 0;
      function useGlobalId(idOverride) {
        const [defaultId, setDefaultId] = reactExports.useState(idOverride);
        const id = idOverride || defaultId;
        reactExports.useEffect(() => {
          if (defaultId == null) {
            globalId += 1;
            setDefaultId(`mui-${globalId}`);
          }
        }, [defaultId]);
        return id;
      }
      const safeReact = {
        ...React
      };
      const maybeReactUseId = safeReact.useId;
      function useId(idOverride) {
        if (maybeReactUseId !== void 0) {
          const reactId = maybeReactUseId();
          return idOverride ?? reactId;
        }
        return useGlobalId(idOverride);
      }
      function useEventCallback(fn) {
        const ref = reactExports.useRef(fn);
        useEnhancedEffect(() => {
          ref.current = fn;
        });
        return reactExports.useRef((...args) => (
          // @ts-expect-error hide `this`
          (0, ref.current)(...args)
        )).current;
      }
      function getScrollbarSize(win = window) {
        const documentWidth = win.document.documentElement.clientWidth;
        return win.innerWidth - documentWidth;
      }
      function isHostComponent(element) {
        return typeof element === "string";
      }
      function appendOwnerState(elementType, otherProps, ownerState) {
        if (elementType === void 0 || isHostComponent(elementType)) {
          return otherProps;
        }
        return {
          ...otherProps,
          ownerState: {
            ...otherProps.ownerState,
            ...ownerState
          }
        };
      }
      function extractEventHandlers(object, excludeKeys = []) {
        if (object === void 0) {
          return {};
        }
        const result = {};
        Object.keys(object).filter((prop) => prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop) => {
          result[prop] = object[prop];
        });
        return result;
      }
      function omitEventHandlers(object) {
        if (object === void 0) {
          return {};
        }
        const result = {};
        Object.keys(object).filter((prop) => !(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop) => {
          result[prop] = object[prop];
        });
        return result;
      }
      function mergeSlotProps(parameters) {
        const {
          getSlotProps,
          additionalProps,
          externalSlotProps,
          externalForwardedProps,
          className
        } = parameters;
        if (!getSlotProps) {
          const joinedClasses2 = clsx(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
          const mergedStyle2 = {
            ...additionalProps == null ? void 0 : additionalProps.style,
            ...externalForwardedProps == null ? void 0 : externalForwardedProps.style,
            ...externalSlotProps == null ? void 0 : externalSlotProps.style
          };
          const props2 = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
          };
          if (joinedClasses2.length > 0) {
            props2.className = joinedClasses2;
          }
          if (Object.keys(mergedStyle2).length > 0) {
            props2.style = mergedStyle2;
          }
          return {
            props: props2,
            internalRef: void 0
          };
        }
        const eventHandlers = extractEventHandlers({
          ...externalForwardedProps,
          ...externalSlotProps
        });
        const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
        const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
        const internalSlotProps = getSlotProps(eventHandlers);
        const joinedClasses = clsx(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = {
          ...internalSlotProps == null ? void 0 : internalSlotProps.style,
          ...additionalProps == null ? void 0 : additionalProps.style,
          ...externalForwardedProps == null ? void 0 : externalForwardedProps.style,
          ...externalSlotProps == null ? void 0 : externalSlotProps.style
        };
        const props = {
          ...internalSlotProps,
          ...additionalProps,
          ...otherPropsWithoutEventHandlers,
          ...componentsPropsWithoutEventHandlers
        };
        if (joinedClasses.length > 0) {
          props.className = joinedClasses;
        }
        if (Object.keys(mergedStyle).length > 0) {
          props.style = mergedStyle;
        }
        return {
          props,
          internalRef: internalSlotProps.ref
        };
      }
      function resolveComponentProps(componentProps, ownerState, slotState) {
        if (typeof componentProps === "function") {
          return componentProps(ownerState, slotState);
        }
        return componentProps;
      }
      function getReactElementRef(element) {
        var _a;
        if (parseInt(reactExports.version, 10) >= 19) {
          return ((_a = element == null ? void 0 : element.props) == null ? void 0 : _a.ref) || null;
        }
        return (element == null ? void 0 : element.ref) || null;
      }
      function useTheme() {
        const theme = useTheme$1(defaultTheme);
        return theme[THEME_ID] || theme;
      }
      function _objectWithoutPropertiesLoose(r, e) {
        if (null == r) return {};
        var t = {};
        for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
          if (-1 !== e.indexOf(n)) continue;
          t[n] = r[n];
        }
        return t;
      }
      function _setPrototypeOf(t, e) {
        return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
          return t2.__proto__ = e2, t2;
        }, _setPrototypeOf(t, e);
      }
      function _inheritsLoose(t, o) {
        t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
      }
      const config = {
        disabled: false
      };
      const TransitionGroupContext = React$1.createContext(null);
      var forceReflow = function forceReflow2(node) {
        return node.scrollTop;
      };
      var UNMOUNTED = "unmounted";
      var EXITED = "exited";
      var ENTERING = "entering";
      var ENTERED = "entered";
      var EXITING = "exiting";
      var Transition = /* @__PURE__ */ function(_React$Component) {
        _inheritsLoose(Transition2, _React$Component);
        function Transition2(props, context) {
          var _this;
          _this = _React$Component.call(this, props, context) || this;
          var parentGroup = context;
          var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
          var initialStatus;
          _this.appearStatus = null;
          if (props.in) {
            if (appear) {
              initialStatus = EXITED;
              _this.appearStatus = ENTERING;
            } else {
              initialStatus = ENTERED;
            }
          } else {
            if (props.unmountOnExit || props.mountOnEnter) {
              initialStatus = UNMOUNTED;
            } else {
              initialStatus = EXITED;
            }
          }
          _this.state = {
            status: initialStatus
          };
          _this.nextCallback = null;
          return _this;
        }
        Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
          var nextIn = _ref.in;
          if (nextIn && prevState.status === UNMOUNTED) {
            return {
              status: EXITED
            };
          }
          return null;
        };
        var _proto = Transition2.prototype;
        _proto.componentDidMount = function componentDidMount() {
          this.updateStatus(true, this.appearStatus);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
          var nextStatus = null;
          if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
              if (status !== ENTERING && status !== ENTERED) {
                nextStatus = ENTERING;
              }
            } else {
              if (status === ENTERING || status === ENTERED) {
                nextStatus = EXITING;
              }
            }
          }
          this.updateStatus(false, nextStatus);
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
          this.cancelNextCallback();
        };
        _proto.getTimeouts = function getTimeouts() {
          var timeout2 = this.props.timeout;
          var exit, enter, appear;
          exit = enter = appear = timeout2;
          if (timeout2 != null && typeof timeout2 !== "number") {
            exit = timeout2.exit;
            enter = timeout2.enter;
            appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
          }
          return {
            exit,
            enter,
            appear
          };
        };
        _proto.updateStatus = function updateStatus(mounting, nextStatus) {
          if (mounting === void 0) {
            mounting = false;
          }
          if (nextStatus !== null) {
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
              if (this.props.unmountOnExit || this.props.mountOnEnter) {
                var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
                if (node) forceReflow(node);
              }
              this.performEnter(mounting);
            } else {
              this.performExit();
            }
          } else if (this.props.unmountOnExit && this.state.status === EXITED) {
            this.setState({
              status: UNMOUNTED
            });
          }
        };
        _proto.performEnter = function performEnter(mounting) {
          var _this2 = this;
          var enter = this.props.enter;
          var appearing = this.context ? this.context.isMounting : mounting;
          var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
          var timeouts = this.getTimeouts();
          var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
          if (!mounting && !enter || config.disabled) {
            this.safeSetState({
              status: ENTERED
            }, function() {
              _this2.props.onEntered(maybeNode);
            });
            return;
          }
          this.props.onEnter(maybeNode, maybeAppearing);
          this.safeSetState({
            status: ENTERING
          }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
              _this2.safeSetState({
                status: ENTERED
              }, function() {
                _this2.props.onEntered(maybeNode, maybeAppearing);
              });
            });
          });
        };
        _proto.performExit = function performExit() {
          var _this3 = this;
          var exit = this.props.exit;
          var timeouts = this.getTimeouts();
          var maybeNode = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
          if (!exit || config.disabled) {
            this.safeSetState({
              status: EXITED
            }, function() {
              _this3.props.onExited(maybeNode);
            });
            return;
          }
          this.props.onExit(maybeNode);
          this.safeSetState({
            status: EXITING
          }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
              _this3.safeSetState({
                status: EXITED
              }, function() {
                _this3.props.onExited(maybeNode);
              });
            });
          });
        };
        _proto.cancelNextCallback = function cancelNextCallback() {
          if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
          }
        };
        _proto.safeSetState = function safeSetState(nextState, callback) {
          callback = this.setNextCallback(callback);
          this.setState(nextState, callback);
        };
        _proto.setNextCallback = function setNextCallback(callback) {
          var _this4 = this;
          var active = true;
          this.nextCallback = function(event) {
            if (active) {
              active = false;
              _this4.nextCallback = null;
              callback(event);
            }
          };
          this.nextCallback.cancel = function() {
            active = false;
          };
          return this.nextCallback;
        };
        _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
          this.setNextCallback(handler);
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
          if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
          }
          if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
          }
          if (timeout2 != null) {
            setTimeout(this.nextCallback, timeout2);
          }
        };
        _proto.render = function render() {
          var status = this.state.status;
          if (status === UNMOUNTED) {
            return null;
          }
          var _this$props = this.props, children = _this$props.children;
          _this$props.in;
          _this$props.mountOnEnter;
          _this$props.unmountOnExit;
          _this$props.appear;
          _this$props.enter;
          _this$props.exit;
          _this$props.timeout;
          _this$props.addEndListener;
          _this$props.onEnter;
          _this$props.onEntering;
          _this$props.onEntered;
          _this$props.onExit;
          _this$props.onExiting;
          _this$props.onExited;
          _this$props.nodeRef;
          var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
          return (
            // allows for nested Transitions
            /* @__PURE__ */ React$1.createElement(TransitionGroupContext.Provider, {
              value: null
            }, typeof children === "function" ? children(status, childProps) : React$1.cloneElement(React$1.Children.only(children), childProps))
          );
        };
        return Transition2;
      }(React$1.Component);
      Transition.contextType = TransitionGroupContext;
      Transition.propTypes = {};
      function noop$1() {
      }
      Transition.defaultProps = {
        in: false,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        enter: true,
        exit: true,
        onEnter: noop$1,
        onEntering: noop$1,
        onEntered: noop$1,
        onExit: noop$1,
        onExiting: noop$1,
        onExited: noop$1
      };
      Transition.UNMOUNTED = UNMOUNTED;
      Transition.EXITED = EXITED;
      Transition.ENTERING = ENTERING;
      Transition.ENTERED = ENTERED;
      Transition.EXITING = EXITING;
      const reflow = (node) => node.scrollTop;
      function getTransitionProps(props, options2) {
        const {
          timeout,
          easing,
          style = {}
        } = props;
        return {
          duration: style.transitionDuration ?? (typeof timeout === "number" ? timeout : timeout[options2.mode] || 0),
          easing: style.transitionTimingFunction ?? (typeof easing === "object" ? easing[options2.mode] : easing),
          delay: style.transitionDelay
        };
      }
      function getPaperUtilityClass(slot) {
        return generateUtilityClass("MuiPaper", slot);
      }
      generateUtilityClasses("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
      const useUtilityClasses$4 = (ownerState) => {
        const {
          square,
          elevation,
          variant,
          classes
        } = ownerState;
        const slots = {
          root: ["root", variant, !square && "rounded", variant === "elevation" && `elevation${elevation}`]
        };
        return composeClasses(slots, getPaperUtilityClass, classes);
      };
      const PaperRoot = styled("div", {
        name: "MuiPaper",
        slot: "Root",
        overridesResolver: (props, styles2) => {
          const {
            ownerState
          } = props;
          return [styles2.root, styles2[ownerState.variant], !ownerState.square && styles2.rounded, ownerState.variant === "elevation" && styles2[`elevation${ownerState.elevation}`]];
        }
      })(memoTheme(({
        theme
      }) => ({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow"),
        variants: [{
          props: ({
            ownerState
          }) => !ownerState.square,
          style: {
            borderRadius: theme.shape.borderRadius
          }
        }, {
          props: {
            variant: "outlined"
          },
          style: {
            border: `1px solid ${(theme.vars || theme).palette.divider}`
          }
        }, {
          props: {
            variant: "elevation"
          },
          style: {
            boxShadow: "var(--Paper-shadow)",
            backgroundImage: "var(--Paper-overlay)"
          }
        }]
      })));
      const Paper = /* @__PURE__ */ reactExports.forwardRef(function Paper2(inProps, ref) {
        var _a;
        const props = useDefaultProps({
          props: inProps,
          name: "MuiPaper"
        });
        const theme = useTheme();
        const {
          className,
          component = "div",
          elevation = 1,
          square = false,
          variant = "elevation",
          ...other
        } = props;
        const ownerState = {
          ...props,
          component,
          elevation,
          square,
          variant
        };
        const classes = useUtilityClasses$4(ownerState);
        return /* @__PURE__ */ jsxRuntimeExports.jsx(PaperRoot, {
          as: component,
          ownerState,
          className: clsx(classes.root, className),
          ref,
          ...other,
          style: {
            ...variant === "elevation" && {
              "--Paper-shadow": (theme.vars || theme).shadows[elevation],
              ...theme.vars && {
                "--Paper-overlay": (_a = theme.vars.overlays) == null ? void 0 : _a[elevation]
              },
              ...!theme.vars && theme.palette.mode === "dark" && {
                "--Paper-overlay": `linear-gradient(${alpha("#fff", getOverlayAlpha(elevation))}, ${alpha("#fff", getOverlayAlpha(elevation))})`
              }
            },
            ...other.style
          }
        });
      });
      function useSlot(name, parameters) {
        const {
          className,
          elementType: initialElementType,
          ownerState,
          externalForwardedProps,
          internalForwardedProps,
          shouldForwardComponentProp = false,
          ...useSlotPropsParams
        } = parameters;
        const {
          component: rootComponent,
          slots = {
            [name]: void 0
          },
          slotProps = {
            [name]: void 0
          },
          ...other
        } = externalForwardedProps;
        const elementType = slots[name] || initialElementType;
        const resolvedComponentsProps = resolveComponentProps(slotProps[name], ownerState);
        const {
          props: {
            component: slotComponent,
            ...mergedProps
          },
          internalRef
        } = mergeSlotProps({
          className,
          ...useSlotPropsParams,
          externalForwardedProps: name === "root" ? other : void 0,
          externalSlotProps: resolvedComponentsProps
        });
        const ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
        const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
        const props = appendOwnerState(elementType, {
          ...name === "root" && !rootComponent && !slots[name] && internalForwardedProps,
          ...name !== "root" && !slots[name] && internalForwardedProps,
          ...mergedProps,
          ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
          },
          ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
          },
          ref
        }, ownerState);
        return [elementType, props];
      }
      function getContainer$1(container) {
        return typeof container === "function" ? container() : container;
      }
      const Portal = /* @__PURE__ */ reactExports.forwardRef(function Portal2(props, forwardedRef) {
        const {
          children,
          container,
          disablePortal = false
        } = props;
        const [mountNode, setMountNode] = reactExports.useState(null);
        const handleRef = useForkRef(/* @__PURE__ */ reactExports.isValidElement(children) ? getReactElementRef(children) : null, forwardedRef);
        useEnhancedEffect(() => {
          if (!disablePortal) {
            setMountNode(getContainer$1(container) || document.body);
          }
        }, [container, disablePortal]);
        useEnhancedEffect(() => {
          if (mountNode && !disablePortal) {
            setRef(forwardedRef, mountNode);
            return () => {
              setRef(forwardedRef, null);
            };
          }
          return void 0;
        }, [forwardedRef, mountNode, disablePortal]);
        if (disablePortal) {
          if (/* @__PURE__ */ reactExports.isValidElement(children)) {
            const newProps = {
              ref: handleRef
            };
            return /* @__PURE__ */ reactExports.cloneElement(children, newProps);
          }
          return children;
        }
        return mountNode ? /* @__PURE__ */ reactDomExports.createPortal(children, mountNode) : mountNode;
      });
      const styles = {
        entering: {
          opacity: 1
        },
        entered: {
          opacity: 1
        }
      };
      const Fade = /* @__PURE__ */ reactExports.forwardRef(function Fade2(props, ref) {
        const theme = useTheme();
        const defaultTimeout = {
          enter: theme.transitions.duration.enteringScreen,
          exit: theme.transitions.duration.leavingScreen
        };
        const {
          addEndListener,
          appear = true,
          children,
          easing,
          in: inProp,
          onEnter,
          onEntered,
          onEntering,
          onExit,
          onExited,
          onExiting,
          style,
          timeout = defaultTimeout,
          // eslint-disable-next-line react/prop-types
          TransitionComponent = Transition,
          ...other
        } = props;
        const nodeRef = reactExports.useRef(null);
        const handleRef = useForkRef(nodeRef, getReactElementRef(children), ref);
        const normalizedTransitionCallback = (callback) => (maybeIsAppearing) => {
          if (callback) {
            const node = nodeRef.current;
            if (maybeIsAppearing === void 0) {
              callback(node);
            } else {
              callback(node, maybeIsAppearing);
            }
          }
        };
        const handleEntering = normalizedTransitionCallback(onEntering);
        const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
          reflow(node);
          const transitionProps = getTransitionProps({
            style,
            timeout,
            easing
          }, {
            mode: "enter"
          });
          node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
          node.style.transition = theme.transitions.create("opacity", transitionProps);
          if (onEnter) {
            onEnter(node, isAppearing);
          }
        });
        const handleEntered = normalizedTransitionCallback(onEntered);
        const handleExiting = normalizedTransitionCallback(onExiting);
        const handleExit = normalizedTransitionCallback((node) => {
          const transitionProps = getTransitionProps({
            style,
            timeout,
            easing
          }, {
            mode: "exit"
          });
          node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
          node.style.transition = theme.transitions.create("opacity", transitionProps);
          if (onExit) {
            onExit(node);
          }
        });
        const handleExited = normalizedTransitionCallback(onExited);
        const handleAddEndListener = (next) => {
          if (addEndListener) {
            addEndListener(nodeRef.current, next);
          }
        };
        return /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionComponent, {
          appear,
          in: inProp,
          nodeRef,
          onEnter: handleEnter,
          onEntered: handleEntered,
          onEntering: handleEntering,
          onExit: handleExit,
          onExited: handleExited,
          onExiting: handleExiting,
          addEndListener: handleAddEndListener,
          timeout,
          ...other,
          children: (state, {
            ownerState,
            ...restChildProps
          }) => {
            return /* @__PURE__ */ reactExports.cloneElement(children, {
              style: {
                opacity: 0,
                visibility: state === "exited" && !inProp ? "hidden" : void 0,
                ...styles[state],
                ...style,
                ...children.props.style
              },
              ref: handleRef,
              ...restChildProps
            });
          }
        });
      });
      function getBackdropUtilityClass(slot) {
        return generateUtilityClass("MuiBackdrop", slot);
      }
      generateUtilityClasses("MuiBackdrop", ["root", "invisible"]);
      const useUtilityClasses$3 = (ownerState) => {
        const {
          classes,
          invisible
        } = ownerState;
        const slots = {
          root: ["root", invisible && "invisible"]
        };
        return composeClasses(slots, getBackdropUtilityClass, classes);
      };
      const BackdropRoot = styled("div", {
        name: "MuiBackdrop",
        slot: "Root",
        overridesResolver: (props, styles2) => {
          const {
            ownerState
          } = props;
          return [styles2.root, ownerState.invisible && styles2.invisible];
        }
      })({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent",
        variants: [{
          props: {
            invisible: true
          },
          style: {
            backgroundColor: "transparent"
          }
        }]
      });
      const Backdrop = /* @__PURE__ */ reactExports.forwardRef(function Backdrop2(inProps, ref) {
        const props = useDefaultProps({
          props: inProps,
          name: "MuiBackdrop"
        });
        const {
          children,
          className,
          component = "div",
          invisible = false,
          open,
          components = {},
          componentsProps = {},
          slotProps = {},
          slots = {},
          TransitionComponent: TransitionComponentProp,
          transitionDuration,
          ...other
        } = props;
        const ownerState = {
          ...props,
          component,
          invisible
        };
        const classes = useUtilityClasses$3(ownerState);
        const backwardCompatibleSlots = {
          transition: TransitionComponentProp,
          root: components.Root,
          ...slots
        };
        const backwardCompatibleSlotProps = {
          ...componentsProps,
          ...slotProps
        };
        const externalForwardedProps = {
          slots: backwardCompatibleSlots,
          slotProps: backwardCompatibleSlotProps
        };
        const [RootSlot, rootProps] = useSlot("root", {
          elementType: BackdropRoot,
          externalForwardedProps,
          className: clsx(classes.root, className),
          ownerState
        });
        const [TransitionSlot, transitionProps] = useSlot("transition", {
          elementType: Fade,
          externalForwardedProps,
          ownerState
        });
        return /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionSlot, {
          in: open,
          timeout: transitionDuration,
          ...other,
          ...transitionProps,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes,
            ref,
            children
          })
        });
      });
      function isOverflowing(container) {
        const doc = ownerDocument(container);
        if (doc.body === container) {
          return ownerWindow(container).innerWidth > doc.documentElement.clientWidth;
        }
        return container.scrollHeight > container.clientHeight;
      }
      function ariaHidden(element, hide) {
        if (hide) {
          element.setAttribute("aria-hidden", "true");
        } else {
          element.removeAttribute("aria-hidden");
        }
      }
      function getPaddingRight(element) {
        return parseInt(ownerWindow(element).getComputedStyle(element).paddingRight, 10) || 0;
      }
      function isAriaHiddenForbiddenOnElement(element) {
        const forbiddenTagNames = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"];
        const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
        const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
        return isForbiddenTagName || isInputHidden;
      }
      function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
        const blacklist = [mountElement, currentElement, ...elementsToExclude];
        [].forEach.call(container.children, (element) => {
          const isNotExcludedElement = !blacklist.includes(element);
          const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
          if (isNotExcludedElement && isNotForbiddenElement) {
            ariaHidden(element, hide);
          }
        });
      }
      function findIndexOf(items, callback) {
        let idx = -1;
        items.some((item, index) => {
          if (callback(item)) {
            idx = index;
            return true;
          }
          return false;
        });
        return idx;
      }
      function handleContainer(containerInfo, props) {
        const restoreStyle = [];
        const container = containerInfo.container;
        if (!props.disableScrollLock) {
          if (isOverflowing(container)) {
            const scrollbarSize = getScrollbarSize(ownerWindow(container));
            restoreStyle.push({
              value: container.style.paddingRight,
              property: "padding-right",
              el: container
            });
            container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;
            const fixedElements = ownerDocument(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element) => {
              restoreStyle.push({
                value: element.style.paddingRight,
                property: "padding-right",
                el: element
              });
              element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
            });
          }
          let scrollContainer;
          if (container.parentNode instanceof DocumentFragment) {
            scrollContainer = ownerDocument(container).body;
          } else {
            const parent = container.parentElement;
            const containerWindow = ownerWindow(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
          }
          restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
          }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
          }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
          });
          scrollContainer.style.overflow = "hidden";
        }
        const restore = () => {
          restoreStyle.forEach(({
            value,
            el,
            property
          }) => {
            if (value) {
              el.style.setProperty(property, value);
            } else {
              el.style.removeProperty(property);
            }
          });
        };
        return restore;
      }
      function getHiddenSiblings(container) {
        const hiddenSiblings = [];
        [].forEach.call(container.children, (element) => {
          if (element.getAttribute("aria-hidden") === "true") {
            hiddenSiblings.push(element);
          }
        });
        return hiddenSiblings;
      }
      class ModalManager {
        constructor() {
          this.modals = [];
          this.containers = [];
        }
        add(modal, container) {
          let modalIndex = this.modals.indexOf(modal);
          if (modalIndex !== -1) {
            return modalIndex;
          }
          modalIndex = this.modals.length;
          this.modals.push(modal);
          if (modal.modalRef) {
            ariaHidden(modal.modalRef, false);
          }
          const hiddenSiblings = getHiddenSiblings(container);
          ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
          const containerIndex = findIndexOf(this.containers, (item) => item.container === container);
          if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
          }
          this.containers.push({
            modals: [modal],
            container,
            restore: null,
            hiddenSiblings
          });
          return modalIndex;
        }
        mount(modal, props) {
          const containerIndex = findIndexOf(this.containers, (item) => item.modals.includes(modal));
          const containerInfo = this.containers[containerIndex];
          if (!containerInfo.restore) {
            containerInfo.restore = handleContainer(containerInfo, props);
          }
        }
        remove(modal, ariaHiddenState = true) {
          const modalIndex = this.modals.indexOf(modal);
          if (modalIndex === -1) {
            return modalIndex;
          }
          const containerIndex = findIndexOf(this.containers, (item) => item.modals.includes(modal));
          const containerInfo = this.containers[containerIndex];
          containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
          this.modals.splice(modalIndex, 1);
          if (containerInfo.modals.length === 0) {
            if (containerInfo.restore) {
              containerInfo.restore();
            }
            if (modal.modalRef) {
              ariaHidden(modal.modalRef, ariaHiddenState);
            }
            ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
          } else {
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            if (nextTop.modalRef) {
              ariaHidden(nextTop.modalRef, false);
            }
          }
          return modalIndex;
        }
        isTopModal(modal) {
          return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
        }
      }
      const candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
      function getTabIndex(node) {
        const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
        if (!Number.isNaN(tabindexAttr)) {
          return tabindexAttr;
        }
        if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) {
          return 0;
        }
        return node.tabIndex;
      }
      function isNonTabbableRadio(node) {
        if (node.tagName !== "INPUT" || node.type !== "radio") {
          return false;
        }
        if (!node.name) {
          return false;
        }
        const getRadio = (selector) => node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
        let roving = getRadio(`[name="${node.name}"]:checked`);
        if (!roving) {
          roving = getRadio(`[name="${node.name}"]`);
        }
        return roving !== node;
      }
      function isNodeMatchingSelectorFocusable(node) {
        if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || isNonTabbableRadio(node)) {
          return false;
        }
        return true;
      }
      function defaultGetTabbable(root) {
        const regularTabNodes = [];
        const orderedTabNodes = [];
        Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i) => {
          const nodeTabIndex = getTabIndex(node);
          if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
            return;
          }
          if (nodeTabIndex === 0) {
            regularTabNodes.push(node);
          } else {
            orderedTabNodes.push({
              documentOrder: i,
              tabIndex: nodeTabIndex,
              node
            });
          }
        });
        return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a) => a.node).concat(regularTabNodes);
      }
      function defaultIsEnabled() {
        return true;
      }
      function FocusTrap(props) {
        const {
          children,
          disableAutoFocus = false,
          disableEnforceFocus = false,
          disableRestoreFocus = false,
          getTabbable = defaultGetTabbable,
          isEnabled = defaultIsEnabled,
          open
        } = props;
        const ignoreNextEnforceFocus = reactExports.useRef(false);
        const sentinelStart = reactExports.useRef(null);
        const sentinelEnd = reactExports.useRef(null);
        const nodeToRestore = reactExports.useRef(null);
        const reactFocusEventTarget = reactExports.useRef(null);
        const activated = reactExports.useRef(false);
        const rootRef = reactExports.useRef(null);
        const handleRef = useForkRef(getReactElementRef(children), rootRef);
        const lastKeydown = reactExports.useRef(null);
        reactExports.useEffect(() => {
          if (!open || !rootRef.current) {
            return;
          }
          activated.current = !disableAutoFocus;
        }, [disableAutoFocus, open]);
        reactExports.useEffect(() => {
          if (!open || !rootRef.current) {
            return;
          }
          const doc = ownerDocument(rootRef.current);
          if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) {
              rootRef.current.setAttribute("tabIndex", "-1");
            }
            if (activated.current) {
              rootRef.current.focus();
            }
          }
          return () => {
            if (!disableRestoreFocus) {
              if (nodeToRestore.current && nodeToRestore.current.focus) {
                ignoreNextEnforceFocus.current = true;
                nodeToRestore.current.focus();
              }
              nodeToRestore.current = null;
            }
          };
        }, [open]);
        reactExports.useEffect(() => {
          if (!open || !rootRef.current) {
            return;
          }
          const doc = ownerDocument(rootRef.current);
          const loopFocus = (nativeEvent) => {
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") {
              return;
            }
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
              ignoreNextEnforceFocus.current = true;
              if (sentinelEnd.current) {
                sentinelEnd.current.focus();
              }
            }
          };
          const contain = () => {
            var _a, _b;
            const rootElement = rootRef.current;
            if (rootElement === null) {
              return;
            }
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
              ignoreNextEnforceFocus.current = false;
              return;
            }
            if (rootElement.contains(doc.activeElement)) {
              return;
            }
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) {
              return;
            }
            if (doc.activeElement !== reactFocusEventTarget.current) {
              reactFocusEventTarget.current = null;
            } else if (reactFocusEventTarget.current !== null) {
              return;
            }
            if (!activated.current) {
              return;
            }
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
              tabbable = getTabbable(rootRef.current);
            }
            if (tabbable.length > 0) {
              const isShiftTab = Boolean(((_a = lastKeydown.current) == null ? void 0 : _a.shiftKey) && ((_b = lastKeydown.current) == null ? void 0 : _b.key) === "Tab");
              const focusNext = tabbable[0];
              const focusPrevious = tabbable[tabbable.length - 1];
              if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                if (isShiftTab) {
                  focusPrevious.focus();
                } else {
                  focusNext.focus();
                }
              }
            } else {
              rootElement.focus();
            }
          };
          doc.addEventListener("focusin", contain);
          doc.addEventListener("keydown", loopFocus, true);
          const interval = setInterval(() => {
            if (doc.activeElement && doc.activeElement.tagName === "BODY") {
              contain();
            }
          }, 50);
          return () => {
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
          };
        }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);
        const onFocus = (event) => {
          if (nodeToRestore.current === null) {
            nodeToRestore.current = event.relatedTarget;
          }
          activated.current = true;
          reactFocusEventTarget.current = event.target;
          const childrenPropsHandler = children.props.onFocus;
          if (childrenPropsHandler) {
            childrenPropsHandler(event);
          }
        };
        const handleFocusSentinel = (event) => {
          if (nodeToRestore.current === null) {
            nodeToRestore.current = event.relatedTarget;
          }
          activated.current = true;
        };
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Fragment, {
          children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
            tabIndex: open ? 0 : -1,
            onFocus: handleFocusSentinel,
            ref: sentinelStart,
            "data-testid": "sentinelStart"
          }), /* @__PURE__ */ reactExports.cloneElement(children, {
            ref: handleRef,
            onFocus
          }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
            tabIndex: open ? 0 : -1,
            onFocus: handleFocusSentinel,
            ref: sentinelEnd,
            "data-testid": "sentinelEnd"
          })]
        });
      }
      function getContainer(container) {
        return typeof container === "function" ? container() : container;
      }
      function getHasTransition(children) {
        return children ? children.props.hasOwnProperty("in") : false;
      }
      const noop = () => {
      };
      const manager = new ModalManager();
      function useModal(parameters) {
        const {
          container,
          disableEscapeKeyDown = false,
          disableScrollLock = false,
          closeAfterTransition = false,
          onTransitionEnter,
          onTransitionExited,
          children,
          onClose,
          open,
          rootRef
        } = parameters;
        const modal = reactExports.useRef({});
        const mountNodeRef = reactExports.useRef(null);
        const modalRef = reactExports.useRef(null);
        const handleRef = useForkRef(modalRef, rootRef);
        const [exited, setExited] = reactExports.useState(!open);
        const hasTransition = getHasTransition(children);
        let ariaHiddenProp = true;
        if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) {
          ariaHiddenProp = false;
        }
        const getDoc = () => ownerDocument(mountNodeRef.current);
        const getModal = () => {
          modal.current.modalRef = modalRef.current;
          modal.current.mount = mountNodeRef.current;
          return modal.current;
        };
        const handleMounted = () => {
          manager.mount(getModal(), {
            disableScrollLock
          });
          if (modalRef.current) {
            modalRef.current.scrollTop = 0;
          }
        };
        const handleOpen = useEventCallback(() => {
          const resolvedContainer = getContainer(container) || getDoc().body;
          manager.add(getModal(), resolvedContainer);
          if (modalRef.current) {
            handleMounted();
          }
        });
        const isTopModal = () => manager.isTopModal(getModal());
        const handlePortalRef = useEventCallback((node) => {
          mountNodeRef.current = node;
          if (!node) {
            return;
          }
          if (open && isTopModal()) {
            handleMounted();
          } else if (modalRef.current) {
            ariaHidden(modalRef.current, ariaHiddenProp);
          }
        });
        const handleClose = reactExports.useCallback(() => {
          manager.remove(getModal(), ariaHiddenProp);
        }, [ariaHiddenProp]);
        reactExports.useEffect(() => {
          return () => {
            handleClose();
          };
        }, [handleClose]);
        reactExports.useEffect(() => {
          if (open) {
            handleOpen();
          } else if (!hasTransition || !closeAfterTransition) {
            handleClose();
          }
        }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
        const createHandleKeyDown = (otherHandlers) => (event) => {
          var _a;
          (_a = otherHandlers.onKeyDown) == null ? void 0 : _a.call(otherHandlers, event);
          if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
          !isTopModal()) {
            return;
          }
          if (!disableEscapeKeyDown) {
            event.stopPropagation();
            if (onClose) {
              onClose(event, "escapeKeyDown");
            }
          }
        };
        const createHandleBackdropClick = (otherHandlers) => (event) => {
          var _a;
          (_a = otherHandlers.onClick) == null ? void 0 : _a.call(otherHandlers, event);
          if (event.target !== event.currentTarget) {
            return;
          }
          if (onClose) {
            onClose(event, "backdropClick");
          }
        };
        const getRootProps = (otherHandlers = {}) => {
          const propsEventHandlers = extractEventHandlers(parameters);
          delete propsEventHandlers.onTransitionEnter;
          delete propsEventHandlers.onTransitionExited;
          const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
          };
          return {
            /*
             * Marking an element with the role presentation indicates to assistive technology
             * that this element should be ignored; it exists to support the web application and
             * is not meant for humans to interact with directly.
             * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
             */
            role: "presentation",
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
          };
        };
        const getBackdropProps = (otherHandlers = {}) => {
          const externalEventHandlers = otherHandlers;
          return {
            "aria-hidden": true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open
          };
        };
        const getTransitionProps2 = () => {
          const handleEnter = () => {
            setExited(false);
            if (onTransitionEnter) {
              onTransitionEnter();
            }
          };
          const handleExited = () => {
            setExited(true);
            if (onTransitionExited) {
              onTransitionExited();
            }
            if (closeAfterTransition) {
              handleClose();
            }
          };
          return {
            onEnter: createChainedFunction(handleEnter, (children == null ? void 0 : children.props.onEnter) ?? noop),
            onExited: createChainedFunction(handleExited, (children == null ? void 0 : children.props.onExited) ?? noop)
          };
        };
        return {
          getRootProps,
          getBackdropProps,
          getTransitionProps: getTransitionProps2,
          rootRef: handleRef,
          portalRef: handlePortalRef,
          isTopModal,
          exited,
          hasTransition
        };
      }
      function getModalUtilityClass(slot) {
        return generateUtilityClass("MuiModal", slot);
      }
      generateUtilityClasses("MuiModal", ["root", "hidden", "backdrop"]);
      const useUtilityClasses$2 = (ownerState) => {
        const {
          open,
          exited,
          classes
        } = ownerState;
        const slots = {
          root: ["root", !open && exited && "hidden"],
          backdrop: ["backdrop"]
        };
        return composeClasses(slots, getModalUtilityClass, classes);
      };
      const ModalRoot = styled("div", {
        name: "MuiModal",
        slot: "Root",
        overridesResolver: (props, styles2) => {
          const {
            ownerState
          } = props;
          return [styles2.root, !ownerState.open && ownerState.exited && styles2.hidden];
        }
      })(memoTheme(({
        theme
      }) => ({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [{
          props: ({
            ownerState
          }) => !ownerState.open && ownerState.exited,
          style: {
            visibility: "hidden"
          }
        }]
      })));
      const ModalBackdrop = styled(Backdrop, {
        name: "MuiModal",
        slot: "Backdrop",
        overridesResolver: (props, styles2) => {
          return styles2.backdrop;
        }
      })({
        zIndex: -1
      });
      const Modal = /* @__PURE__ */ reactExports.forwardRef(function Modal2(inProps, ref) {
        const props = useDefaultProps({
          name: "MuiModal",
          props: inProps
        });
        const {
          BackdropComponent = ModalBackdrop,
          BackdropProps,
          classes: classesProp,
          className,
          closeAfterTransition = false,
          children,
          container,
          component,
          components = {},
          componentsProps = {},
          disableAutoFocus = false,
          disableEnforceFocus = false,
          disableEscapeKeyDown = false,
          disablePortal = false,
          disableRestoreFocus = false,
          disableScrollLock = false,
          hideBackdrop = false,
          keepMounted = false,
          onBackdropClick,
          onClose,
          onTransitionEnter,
          onTransitionExited,
          open,
          slotProps = {},
          slots = {},
          // eslint-disable-next-line react/prop-types
          theme,
          ...other
        } = props;
        const propsWithDefaults = {
          ...props,
          closeAfterTransition,
          disableAutoFocus,
          disableEnforceFocus,
          disableEscapeKeyDown,
          disablePortal,
          disableRestoreFocus,
          disableScrollLock,
          hideBackdrop,
          keepMounted
        };
        const {
          getRootProps,
          getBackdropProps,
          getTransitionProps: getTransitionProps2,
          portalRef,
          isTopModal,
          exited,
          hasTransition
        } = useModal({
          ...propsWithDefaults,
          rootRef: ref
        });
        const ownerState = {
          ...propsWithDefaults,
          exited
        };
        const classes = useUtilityClasses$2(ownerState);
        const childProps = {};
        if (children.props.tabIndex === void 0) {
          childProps.tabIndex = "-1";
        }
        if (hasTransition) {
          const {
            onEnter,
            onExited
          } = getTransitionProps2();
          childProps.onEnter = onEnter;
          childProps.onExited = onExited;
        }
        const externalForwardedProps = {
          slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
          },
          slotProps: {
            ...componentsProps,
            ...slotProps
          }
        };
        const [RootSlot, rootProps] = useSlot("root", {
          ref,
          elementType: ModalRoot,
          externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component
          },
          getSlotProps: getRootProps,
          ownerState,
          className: clsx(className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
        });
        const [BackdropSlot, backdropProps] = useSlot("backdrop", {
          ref: BackdropProps == null ? void 0 : BackdropProps.ref,
          elementType: BackdropComponent,
          externalForwardedProps,
          shouldForwardComponentProp: true,
          additionalProps: BackdropProps,
          getSlotProps: (otherHandlers) => {
            return getBackdropProps({
              ...otherHandlers,
              onClick: (event) => {
                if (onBackdropClick) {
                  onBackdropClick(event);
                }
                if (otherHandlers == null ? void 0 : otherHandlers.onClick) {
                  otherHandlers.onClick(event);
                }
              }
            });
          },
          className: clsx(BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
          ownerState
        });
        if (!keepMounted && !open && (!hasTransition || exited)) {
          return null;
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
          ref: portalRef,
          container,
          disablePortal,
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(RootSlot, {
            ...rootProps,
            children: [!hideBackdrop && BackdropComponent ? /* @__PURE__ */ jsxRuntimeExports.jsx(BackdropSlot, {
              ...backdropProps
            }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap, {
              disableEnforceFocus,
              disableAutoFocus,
              disableRestoreFocus,
              isEnabled: isTopModal,
              open,
              children: /* @__PURE__ */ reactExports.cloneElement(children, childProps)
            })]
          })
        });
      });
      function getDialogUtilityClass(slot) {
        return generateUtilityClass("MuiDialog", slot);
      }
      const dialogClasses = generateUtilityClasses("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]);
      const DialogContext = /* @__PURE__ */ reactExports.createContext({});
      const DialogBackdrop = styled(Backdrop, {
        name: "MuiDialog",
        slot: "Backdrop",
        overrides: (props, styles2) => styles2.backdrop
      })({
        // Improve scrollable dialog support.
        zIndex: -1
      });
      const useUtilityClasses$1 = (ownerState) => {
        const {
          classes,
          scroll,
          maxWidth,
          fullWidth,
          fullScreen
        } = ownerState;
        const slots = {
          root: ["root"],
          container: ["container", `scroll${capitalize(scroll)}`],
          paper: ["paper", `paperScroll${capitalize(scroll)}`, `paperWidth${capitalize(String(maxWidth))}`, fullWidth && "paperFullWidth", fullScreen && "paperFullScreen"]
        };
        return composeClasses(slots, getDialogUtilityClass, classes);
      };
      const DialogRoot = styled(Modal, {
        name: "MuiDialog",
        slot: "Root",
        overridesResolver: (props, styles2) => styles2.root
      })({
        "@media print": {
          // Use !important to override the Modal inline-style.
          position: "absolute !important"
        }
      });
      const DialogContainer = styled("div", {
        name: "MuiDialog",
        slot: "Container",
        overridesResolver: (props, styles2) => {
          const {
            ownerState
          } = props;
          return [styles2.container, styles2[`scroll${capitalize(ownerState.scroll)}`]];
        }
      })({
        height: "100%",
        "@media print": {
          height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        variants: [{
          props: {
            scroll: "paper"
          },
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }
        }, {
          props: {
            scroll: "body"
          },
          style: {
            overflowY: "auto",
            overflowX: "hidden",
            textAlign: "center",
            "&::after": {
              content: '""',
              display: "inline-block",
              verticalAlign: "middle",
              height: "100%",
              width: "0"
            }
          }
        }]
      });
      const DialogPaper = styled(Paper, {
        name: "MuiDialog",
        slot: "Paper",
        overridesResolver: (props, styles2) => {
          const {
            ownerState
          } = props;
          return [styles2.paper, styles2[`scrollPaper${capitalize(ownerState.scroll)}`], styles2[`paperWidth${capitalize(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles2.paperFullWidth, ownerState.fullScreen && styles2.paperFullScreen];
        }
      })(memoTheme(({
        theme
      }) => ({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        "@media print": {
          overflowY: "visible",
          boxShadow: "none"
        },
        variants: [{
          props: {
            scroll: "paper"
          },
          style: {
            display: "flex",
            flexDirection: "column",
            maxHeight: "calc(100% - 64px)"
          }
        }, {
          props: {
            scroll: "body"
          },
          style: {
            display: "inline-block",
            verticalAlign: "middle",
            textAlign: "initial"
          }
        }, {
          props: ({
            ownerState
          }) => !ownerState.maxWidth,
          style: {
            maxWidth: "calc(100% - 64px)"
          }
        }, {
          props: {
            maxWidth: "xs"
          },
          style: {
            maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
            [`&.${dialogClasses.paperScrollBody}`]: {
              [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
                maxWidth: "calc(100% - 64px)"
              }
            }
          }
        }, ...Object.keys(theme.breakpoints.values).filter((maxWidth) => maxWidth !== "xs").map((maxWidth) => ({
          props: {
            maxWidth
          },
          style: {
            maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
            [`&.${dialogClasses.paperScrollBody}`]: {
              [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 32 * 2)]: {
                maxWidth: "calc(100% - 64px)"
              }
            }
          }
        })), {
          props: ({
            ownerState
          }) => ownerState.fullWidth,
          style: {
            width: "calc(100% - 64px)"
          }
        }, {
          props: ({
            ownerState
          }) => ownerState.fullScreen,
          style: {
            margin: 0,
            width: "100%",
            maxWidth: "100%",
            height: "100%",
            maxHeight: "none",
            borderRadius: 0,
            [`&.${dialogClasses.paperScrollBody}`]: {
              margin: 0,
              maxWidth: "100%"
            }
          }
        }]
      })));
      const Dialog = /* @__PURE__ */ reactExports.forwardRef(function Dialog2(inProps, ref) {
        const props = useDefaultProps({
          props: inProps,
          name: "MuiDialog"
        });
        const theme = useTheme();
        const defaultTransitionDuration = {
          enter: theme.transitions.duration.enteringScreen,
          exit: theme.transitions.duration.leavingScreen
        };
        const {
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledbyProp,
          "aria-modal": ariaModal = true,
          BackdropComponent,
          BackdropProps,
          children,
          className,
          disableEscapeKeyDown = false,
          fullScreen = false,
          fullWidth = false,
          maxWidth = "sm",
          onBackdropClick,
          onClick,
          onClose,
          open,
          PaperComponent = Paper,
          PaperProps = {},
          scroll = "paper",
          slots = {},
          slotProps = {},
          TransitionComponent = Fade,
          transitionDuration = defaultTransitionDuration,
          TransitionProps,
          ...other
        } = props;
        const ownerState = {
          ...props,
          disableEscapeKeyDown,
          fullScreen,
          fullWidth,
          maxWidth,
          scroll
        };
        const classes = useUtilityClasses$1(ownerState);
        const backdropClick = reactExports.useRef();
        const handleMouseDown = (event) => {
          backdropClick.current = event.target === event.currentTarget;
        };
        const handleBackdropClick = (event) => {
          if (onClick) {
            onClick(event);
          }
          if (!backdropClick.current) {
            return;
          }
          backdropClick.current = null;
          if (onBackdropClick) {
            onBackdropClick(event);
          }
          if (onClose) {
            onClose(event, "backdropClick");
          }
        };
        const ariaLabelledby = useId(ariaLabelledbyProp);
        const dialogContextValue = reactExports.useMemo(() => {
          return {
            titleId: ariaLabelledby
          };
        }, [ariaLabelledby]);
        const backwardCompatibleSlots = {
          transition: TransitionComponent,
          ...slots
        };
        const backwardCompatibleSlotProps = {
          transition: TransitionProps,
          paper: PaperProps,
          backdrop: BackdropProps,
          ...slotProps
        };
        const externalForwardedProps = {
          slots: backwardCompatibleSlots,
          slotProps: backwardCompatibleSlotProps
        };
        const [RootSlot, rootSlotProps] = useSlot("root", {
          elementType: DialogRoot,
          shouldForwardComponentProp: true,
          externalForwardedProps,
          ownerState,
          className: clsx(classes.root, className),
          ref
        });
        const [BackdropSlot, backdropSlotProps] = useSlot("backdrop", {
          elementType: DialogBackdrop,
          shouldForwardComponentProp: true,
          externalForwardedProps,
          ownerState
        });
        const [PaperSlot, paperSlotProps] = useSlot("paper", {
          elementType: DialogPaper,
          shouldForwardComponentProp: true,
          externalForwardedProps,
          ownerState,
          className: clsx(classes.paper, PaperProps.className)
        });
        const [ContainerSlot, containerSlotProps] = useSlot("container", {
          elementType: DialogContainer,
          externalForwardedProps,
          ownerState,
          className: clsx(classes.container)
        });
        const [TransitionSlot, transitionSlotProps] = useSlot("transition", {
          elementType: Fade,
          externalForwardedProps,
          ownerState,
          additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
          }
        });
        return /* @__PURE__ */ jsxRuntimeExports.jsx(RootSlot, {
          closeAfterTransition: true,
          slots: {
            backdrop: BackdropSlot
          },
          slotProps: {
            backdrop: {
              transitionDuration,
              as: BackdropComponent,
              ...backdropSlotProps
            }
          },
          disableEscapeKeyDown,
          onClose,
          open,
          onClick: handleBackdropClick,
          ...rootSlotProps,
          ...other,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionSlot, {
            ...transitionSlotProps,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerSlot, {
              onMouseDown: handleMouseDown,
              ...containerSlotProps,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(PaperSlot, {
                as: PaperComponent,
                elevation: 24,
                role: "dialog",
                "aria-describedby": ariaDescribedby,
                "aria-labelledby": ariaLabelledby,
                "aria-modal": ariaModal,
                ...paperSlotProps,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContext.Provider, {
                  value: dialogContextValue,
                  children
                })
              })
            })
          })
        });
      });
      function getDialogContentUtilityClass(slot) {
        return generateUtilityClass("MuiDialogContent", slot);
      }
      generateUtilityClasses("MuiDialogContent", ["root", "dividers"]);
      const dialogTitleClasses = generateUtilityClasses("MuiDialogTitle", ["root"]);
      const useUtilityClasses = (ownerState) => {
        const {
          classes,
          dividers
        } = ownerState;
        const slots = {
          root: ["root", dividers && "dividers"]
        };
        return composeClasses(slots, getDialogContentUtilityClass, classes);
      };
      const DialogContentRoot = styled("div", {
        name: "MuiDialogContent",
        slot: "Root",
        overridesResolver: (props, styles2) => {
          const {
            ownerState
          } = props;
          return [styles2.root, ownerState.dividers && styles2.dividers];
        }
      })(memoTheme(({
        theme
      }) => ({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px",
        variants: [{
          props: ({
            ownerState
          }) => ownerState.dividers,
          style: {
            padding: "16px 24px",
            borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
            borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
          }
        }, {
          props: ({
            ownerState
          }) => !ownerState.dividers,
          style: {
            [`.${dialogTitleClasses.root} + &`]: {
              paddingTop: 0
            }
          }
        }]
      })));
      const DialogContent = /* @__PURE__ */ reactExports.forwardRef(function DialogContent2(inProps, ref) {
        const props = useDefaultProps({
          props: inProps,
          name: "MuiDialogContent"
        });
        const {
          className,
          dividers = false,
          ...other
        } = props;
        const ownerState = {
          ...props,
          dividers
        };
        const classes = useUtilityClasses(ownerState);
        return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContentRoot, {
          className: clsx(classes.root, className),
          ownerState,
          ref,
          ...other
        });
      });
      const MainWrapper = j("div")`
  max-width: 1280px;
  margin: 0 auto;
  margin-top: 24px;
  --slide-size: 25%;
  --slide-height: 357px;
  --slide-spacing: 12px;
  @media screen and (max-width: 1068px) {
    --slide-size: 33%;
  }
  @media screen and (max-width: 767px) {
    --slide-spacing: 8px;
    --slide-size: 40%;
    overflow-x: hidden;
  }
`;
      const viewportCls = u`
  position: relative;
  overflow: hidden;
  @media screen and (max-width: 767px) {
    padding-left: var(--slide-spacing);
  }
`;
      const containerCls = u({
        display: "flex",
        touchAction: "pan-y pinch-zoom",
        marginLeft: "calc(var(--slide-spacing) * -1)",
        marginRight: "calc(var(--slide-spacing) * -1)"
      });
      const navigatorCls = u`
  position: relative;
  svg {
    width: 24px;
    height: 24px;
  }
  .embla__button {
    position: absolute;
    padding: 8px 12px;
    height: 40px;
    color: white;
    vertical-align: top;
    margin-top: -200px;
  }
  .embla__button--prev {
    left: -48px;
  }
  .embla__button--next {
    right: -48px;
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
`;
      const slideCls = u`
  flex: 0 0 var(--slide-size);
  min-width: 0;
  transform: translate3d(0, 0, 0);
  padding-left: var(--slide-spacing);
  padding-right: var(--slide-spacing);
  box-sizing: border-box;

  h5 {
    font-size: 18px;
    margin-top: 24px;
    min-height: 26px;
    margin-bottom: 24px;
    line-height: 1;
    color: #fff;
    word-break: break-all;

    @media screen and (max-width: 767px) {
      font-size: 14px;
      min-height: 28px;
      margin-top: 18px;
      margin-bottom: 18px;
    }
  }

  .carousel-slide-content {
    position: relative;
    padding: 20px;
    border-radius: 20px;
    background: linear-gradient(205.93deg, #BAC7D2 2.76%, rgba(2, 2, 2, 0) 102.48%);
    z-index: -1;
    &:before {
      content: '';
      position: absolute;
      top: 1px;
      left: 1px;
      right: 1px;
      bottom: 1px;
      border-radius: inherit;
      background: linear-gradient(180deg, #000000 0%, #181B22 100%);
      border-radius: 20px;
      z-index: -1;
    }
    &:hover {
      .carousel-slide-content-bg {
        img {
          transform: scale(1.07);
        }
      }
    }
    @media screen and (max-width: 767px) {
      padding: 20px 11.5px;
    }
  }

  .carousel-slide-content-bg {
    position: relative;
    height: 200px;
    overflow: hidden;
    border-radius: 15px;
    user-select: none;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(136.6deg, rgba(0, 0, 0, 0) 4.97%, #7A83A5 97.56%);
      z-index: -1;
    }
    img {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      transform-origin: center;
      transition: transform 0.3s ease-in;
      object-fit: cover;
    }
    @media screen and (max-width: 767px) {
      height: 120px;
    }
  }

  .carousel-slide-centent-bg-eclipse {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    z-index: -1;
  }

  .carousel-slide-content-btn {
    position: relative;
    display: inline-block;
    padding: 8px 14px;
    padding-left: 36px;
    border-radius: 999px;
    background-color: #fff;
    color: #222;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    svg {
      position: absolute;
      top: 50%;
      left: 14px;
      transform: translateY(-50%);
      width: 18px;
      height: 18px;
    }
    &:hover {
      background: linear-gradient(90deg, #35EBFF 0%, #025BFF 100%);
      color: #fff;
    }
    @media screen and (max-width: 767px) {
      width: 100%;
      text-align: center;
      padding-left: 14px;
      svg {
        display: inline-block;
        position: initial;
        transform: none;
        margin-right: 5px;
        top: initial;
        left: initial;
        vertical-align: top;
        transform: translateY(1px);
      }
    }
  }
`;
      const dialogContentCls = u`
  &.MuiPaper-root {
    width: 90vw;
    max-width: 1128px;
    max-height: 80vh;
    backdrop-filter: blur(60px);
    background-color: rgba(24, 27, 34, 0.3);
    box-sizing: border-box;
    border-radius: 26px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    overflow-x: hidden;
    color: #fff;
    @media screen and (max-width: 767px) {
      width: 100vw;
      height: 100vh;
      margin: 0;
      max-height: 100vh;
      border-radius: 0;
      box-shadow: none;
    }
  }

  .MuiDialogContent-root {
    min-height: 480px;
    padding: 80px 140px;
    padding-right: 180px;
    margin-right: -40px;
    @media screen and (max-width: 767px) {
      padding: 80px 24px 0;
      margin-right: 0;
    }
  }

  h5,
  p {
    text-align: center;
    color: #fff;
  }
  h5 {
    font-size: 26px;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 32px;
  }

  .dialog-video {
    height: 480px;
    iframe {
      width: 100%;
      height: 100%;
      border: none;
      margin-top: 48px;
      border-radius: 20px;
    }
    @media screen and (max-width: 767px) {
      max-height: 50.6vw;
      iframe {
        border-radius: 8px;
        margin-top: 24px;
      }
    }
  }

  .dialog-close {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 999px;
    background-color: #fff;
    position: absolute;
    box-sizing: border-box;
    top: 32px;
    right: 32px;
    padding: 11px;
    cursor: pointer;
    color: #000;
    z-index: 200;
    svg {
      pointer-events: none;
    }
  }
`;
      const dialogRootCls = u`
  .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, .3);
    backdrop-filter: blur(3px);
  }
`;
      const options = {
        loop: true,
        align: "start"
      };
      const EclipseSvgStr = `<svg width="260" height="200" viewBox="0 0 260 200" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_1502_909" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="260" height="200"><rect width="260" height="200" rx="15" fill="url(#paint0_linear_1502_909)"/></mask><g mask="url(#mask0_1502_909)"><g style="mix-blend-mode:plus-lighter"><path d="M301.469 -15C301.469 70.2885 226.116 139.5 133.071 139.5C40.0261 139.5 -35.3268 70.2885 -35.3268 -15C-35.3268 -100.288 40.0261 -169.5 133.071 -169.5C226.116 -169.5 301.469 -100.288 301.469 -15Z" fill="url(#paint1_linear_1502_909)" style="mix-blend-mode:plus-lighter"/><path d="M301.469 -15C301.469 70.2885 226.116 139.5 133.071 139.5C40.0261 139.5 -35.3268 70.2885 -35.3268 -15C-35.3268 -100.288 40.0261 -169.5 133.071 -169.5C226.116 -169.5 301.469 -100.288 301.469 -15Z" fill="url(#paint2_radial_1502_909)" style="mix-blend-mode:plus-lighter"/><path d="M301.469 -15C301.469 70.2885 226.116 139.5 133.071 139.5C40.0261 139.5 -35.3268 70.2885 -35.3268 -15C-35.3268 -100.288 40.0261 -169.5 133.071 -169.5C226.116 -169.5 301.469 -100.288 301.469 -15Z" stroke="url(#paint3_linear_1502_909)"/></g></g><defs><linearGradient id="paint0_linear_1502_909" x1="130" y1="0" x2="130" y2="200" gradientUnits="userSpaceOnUse"><stop stop-color="#181B22"/><stop offset="1" stop-color="#181B22"/></linearGradient><linearGradient id="paint1_linear_1502_909" x1="23.0315" y1="20.5" x2="208.182" y2="169.913" gradientUnits="userSpaceOnUse"><stop offset="0.348193" stop-opacity="0"/><stop offset="1" stop-color="#7F7F7F"/></linearGradient><radialGradient id="paint2_radial_1502_909" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(98.7883 -22.6869) rotate(48.5391) scale(219.072 222.201)"><stop offset="0.73028" stop-color="#0D0D0D" stop-opacity="0"/><stop offset="0.986122" stop-color="white"/></radialGradient><linearGradient id="paint3_linear_1502_909" x1="273.446" y1="-170" x2="102.498" y2="213.142" gradientUnits="userSpaceOnUse"><stop stop-color="#BAC7D2"/><stop offset="1" stop-color="#020202" stop-opacity="0"/></linearGradient></defs></svg>`;
      const CloseSvgStr = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 16.5L16.5 1.50002" stroke="currentColor" stroke-width="3" stroke-linecap="round"/><path d="M16.5 16.5L1.50002 1.50002" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>`;
      function UserStory(props) {
        const {
          items
        } = props;
        const [emblaRef, emblaApi] = useEmblaCarousel(options);
        const [, setSelectedIndex] = reactExports.useState(0);
        const [, setScrollSnaps] = reactExports.useState([]);
        const [isDialogOpen, setDialogOpen] = reactExports.useState(false);
        const [dialogContent, setDialogContent] = reactExports.useState();
        const isMobile = useMobile();
        const {
          prevBtnDisabled,
          nextBtnDisabled,
          onPrevButtonClick,
          onNextButtonClick
        } = usePrevNextButtons(emblaApi);
        const onInit = reactExports.useCallback((emblaApi2) => {
          setScrollSnaps(emblaApi2.scrollSnapList());
        }, []);
        const onSelect = reactExports.useCallback((emblaApi2) => {
          setSelectedIndex(emblaApi2.selectedScrollSnap());
        }, []);
        const onDialogClose = reactExports.useCallback(() => {
          setDialogOpen(false);
          setDialogContent(void 0);
        }, []);
        reactExports.useEffect(() => {
          if (!emblaApi) return;
          onInit(emblaApi);
          onSelect(emblaApi);
          emblaApi.on("reInit", onInit).on("reInit", onSelect).on("select", onSelect);
        }, []);
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(MainWrapper, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: viewportCls, ref: emblaRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: containerCls, children: items == null ? void 0 : items.map((item, index) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: slideCls, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "carousel-slide-content", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "carousel-slide-content-bg", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: item.image || props.placeholder_image, alt: item.title }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "carousel-slide-centent-bg-eclipse", dangerouslySetInnerHTML: {
                __html: EclipseSvgStr
              } })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: item.title }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "carousel-slide-content-btn", onClick: () => {
              setDialogContent(item);
              setDialogOpen(true);
            }, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", version: "1.1", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "m 14.25494,7.7716807 c 1.3333,0.7698 1.3333,2.6942993 0,3.4640993 l -7.5000007,4.33015 c -1.33334,0.7698 -3,-0.1925 -3,-1.7321 V 5.1736007 c 0,-1.5396 1.66667,-2.501849 3,-1.732048 z", fill: "currentColor" }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: isMobile ? "More" : "Learn More" })
            ] })
          ] }) }, index)) }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: navigatorCls, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(PrevButton, { onClick: onPrevButtonClick, disabled: prevBtnDisabled }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(NextButton, { onClick: onNextButtonClick, disabled: nextBtnDisabled })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Dialog, { open: isDialogOpen, classes: {
            paper: dialogContentCls,
            root: dialogRootCls
          }, onClose: onDialogClose, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: "dialog-close", dangerouslySetInnerHTML: {
              __html: CloseSvgStr
            }, onClick: onDialogClose }) }),
            dialogContent && /* @__PURE__ */ jsxRuntimeExports.jsxs(DialogContent, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: dialogContent.content_title }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { dangerouslySetInnerHTML: {
                __html: dialogContent.content
              } }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dialog-video", children: dialogContent.video && (dialogContent.video.type === "youtube" ? /* @__PURE__ */ jsxRuntimeExports.jsx("iframe", { "data-src": `https://www.youtube.com/embed/${dialogContent.video.id}?loop=0&autoplay=0&mute=1&controls=1&playlist=${dialogContent.video.id}&iv_load_policy=3&disablekb=1&controls=0&playsinline=1&enablejsapi=1`, className: "lazyload", allow: "autoplay; encrypted-media", allowFullScreen: true, title: props.heading || "", tabIndex: -1 }) : dialogContent.video.type === "vimeo" ? /* @__PURE__ */ jsxRuntimeExports.jsx("iframe", { src: `https://player.vimeo.com/video/${dialogContent.video.id}?autoplay=0&muted=1&loop=1`, allow: "autoplay; fullscreen", allowFullScreen: true, title: "{{ section.settings.heading | escape }}", tabIndex: -1 }) : null) })
            ] })
          ] })
        ] });
      }
    }
  };
});
